/* eslint-disable max-len */
import Fingerprint2 from 'fingerprintjs2';
import md5 from 'md5';
import moment from 'moment';
import isEqual from 'lodash.isequal';
import toCamelCase from '../utils/toCamelCase';
import {
    CIB_LEAD_FINGERPRINT,
    CIB_LEAD_UTM,
    CIB_LEAD_VISIT_TIMESTAMP,
    CIB_LOAN_LEAD,
    USER_LOCATION,
    CIB_DCL_UID_SET,
} from '../constants/cookies';
import inputmask from '../lib/inputmask';

const debetCardLabels = {
    '/for-individuals/cards/debet-cards': 'debitCards',
    '/for-individuals/cards/debet-cards/advanced': 'debitCardsAdvanced',
    '/for-individuals/cards/debet-cards/mir-supreme': 'debitCardsMirSupreme',
    '/for-individuals/cards/debet-cards/mir-supreme-plus': 'debitCardsMirSupremePlus',
    '/for-individuals/cards/debet-cards/pens': 'debitCardsPens',
    '/for-individuals/cards/debet-cards/gk-rostov-card': 'debitCardsGkRostov',
    '/for-individuals/cards/debet-cards/karta-bolelshchika-futbolnogo-kluba-chaika': 'debitCardsFkChaika',
    '/for-individuals/cards/debet-cards/selfemployed-card': 'debitCardsSelfEmployed',
    '/for-individuals/cards/debet-cards/servisnaia-karta-mir': 'debitCardsServiceMir',
    '/for-individuals/cards/debet-cards/mir-child': 'debitCardsMirChild',
};

const creditLabels = {
    '/for-individuals/crediting': 'loan',
    '/for-individuals/crediting/consumer-loan': 'loanConsumer',
    '/for-individuals/crediting/consumer-loan/credit-for-all': 'loanForAll',
    '/for-individuals/crediting/self-employed': 'loanSelfEmployed',
    '/for-individuals/crediting/car-loans': 'loanCar',
};

const mortgageLabels = {
    '/for-individuals/mortgage': 'mortgage',
    '/for-individuals/mortgage/green-mortgage': 'mortgageGreen',
    '/for-individuals/mortgage/it-mortgage': 'mortgageIt',
    '/for-individuals/refinancing/mortgage-refinancing': 'mortgageRefinancing',
    '/for-individuals/mortgage/mortgage-children': 'mortgageChildren',
    '/for-individuals/mortgage/building': 'mortgageBuilding',
    '/for-individuals/mortgage/new-building': 'mortgageNewBuilding',
    '/for-individuals/mortgage/commercial-property': 'mortgageCommercial',
    '/for-individuals/mortgage/village': 'mortgageVillage',
};

const buisnessLoanLabels = {
    '/business/business-crediting/promyshlennaia-ipoteka': 'promyshlennaia-ipoteka',
    '/business/business-crediting/lgotnye-kredity-dlia-importerov': 'lgotnye-kredity-dlia-importerov',
    '/business/business-crediting/zelenaia-ipoteka-dlia-biznesa': 'zelenaia-ipoteka-dlia-biznesa',
    '/business/business-crediting/psk-pod-poruchitelstvo-msp-korporatsii': 'psk-pod-poruchitelstvo-msp-korporatsii',
    '/business/business-crediting/onlain-kredit': 'onlain-kredit',
    '/business/business-crediting/biznes-kredit-dlia-zhenshchin': 'biznes-kredit-dlia-zhenshchin',
    '/business/business-crediting/startap': 'startap',
    '/business/business-crediting/sotsialnaia-otvetstvennost': 'sotsialnaia-otvetstvennost',
    '/business/business-crediting/transformatsiia-biznesa': 'transformatsiia-biznesa',
    '/business/business-crediting/sezonnoe-kreditnoe-predlozhenie': 'sezonnoe-kreditnoe-predlozhenie',
    '/business/business-crediting/lgotnye-kredity-apk': 'lgotnye-kredity-apk',
    '/business/business-crediting/lgotnyi-kredit-dlia-malogo-i-srednego-biznesa': 'lgotnyi-kredit-dlia-malogo-i-srednego-biznesa',
    '/business/business-crediting/overdraft': 'overdraft',
    '/business/business-crediting/kommercheskaia-ipoteka': 'kommercheskaia-ipoteka',
    '/business/business-crediting/avtomobilnyi-dlia-malogo-biznesa': 'avtomobilnyi-dlia-malogo-biznesa',
    '/business/business-crediting/investitsionnyi-kredit-dlia-modernizatsii-energoeffektivnykh-tekhnologii': 'investitsionnyi-kredit-dlia-modernizatsii-energoeffektivnykh-tekhnologii',
    '/business/business-crediting/na-popolnenie-oborotnykh-sredstv': 'na-popolnenie-oborotnykh-sredstv',
    '/business/business-crediting/na-priobretenie-selkhoztekhniki': 'na-priobretenie-selkhoztekhniki',
    '/business/business-crediting/kreditovanie-tszh-i-uk': 'kreditovanie-tszh-i-uk',
    '/business/business-crediting/bankovskie-garantii': 'bankovskie-garantii',
    '/business/business-crediting/kredit-pod-kontrakt': 'kredit-pod-kontrakt',
    '/business/business-crediting/lgotnyi-period-106-fz-i-restrukturizatsiia-kreditov': 'lgotnyi-period-106-fz-i-restrukturizatsiia-kreditov',
    '/business/business-crediting/zontichnoe-poruchitelstvo-msp-korporatsii': 'zontichnoe-poruchitelstvo-msp-korporatsii',
};

const commonLabels = {
    // '/for-individuals/safe-boxes': 'safe-boxes',
};

const LOAN_TYPES = {
    mortgage: 'individualLoanMortgage',
    credit: 'individualLoanCredit',
    autocredit: 'individualLoanAutocredit',
};

const setLeadFingerprint = (app) => {
    return new Promise((resolve) => {
        if (!app.$cookies.get(CIB_LEAD_FINGERPRINT)) {
            Fingerprint2.getV18((hash) => {
                app.$cookies.set(CIB_LEAD_FINGERPRINT, hash, {
                    path: '/',
                    maxAge: 60 * 60 * 24 * 365,
                });
                resolve(hash);
            });
        } else {
            resolve(app.$cookies.get(CIB_LEAD_FINGERPRINT));
        }
    });
};

const setLeadVisitUnix = (app) => {
    const visitTimeStamp = moment().unix();
    app.$cookies.set(CIB_LEAD_VISIT_TIMESTAMP, visitTimeStamp, {
        path: '/',
        maxAge: 60 * 60 * 24 * 1,
    });

    return visitTimeStamp;
};

const getLeadVisitUnix = (app) => {
    return app.$cookies.get(CIB_LEAD_VISIT_TIMESTAMP);
};

const getDebetCardsLeadModel = async(ctx, payload) => {
    const fingerprint = await setLeadFingerprint(ctx.app);

    return {
        name: payload.name,
        phone: payload.phone,
        fingerprint,
        callCenterLabel: debetCardLabels[ctx.route.path],
        link: ctx.route.path,
        queryParams: ctx.app.$cookies.get(CIB_LEAD_UTM) ?? ctx.route.query,
    };
};

// Website visitors lead
const fetchVisitorLead = async(ctx, skipСondition = false) => {
    const isSendAbort = !!getLeadVisitUnix(ctx.app)
        && isEqual(ctx.app.$cookies.get(CIB_LEAD_UTM), ctx.route.query)
        && !skipСondition;
    const hasUidCookie = !!ctx.app.$cookies.get(CIB_DCL_UID_SET);

    if (hasUidCookie && isSendAbort) {
        return;
    }

    ctx.app.$cookies.set(CIB_LEAD_UTM, ctx.route.query, {
        path: '/',
        maxAge: 60 * 60 * 24 * 7,
    });

    const browserId = await setLeadFingerprint(ctx.app);

    const visitTimestamp = setLeadVisitUnix(ctx.app);
    const urmParamsString = new URLSearchParams(ctx.route.query);
    const payload = {
        browserId,
        utmLabels: urmParamsString.toString() || null,
        region: ctx.app.$cookies.get(USER_LOCATION)?.name ?? null,
        timestamp: visitTimestamp,
        url: ctx.route.path,
    };

    try {
        ctx.app.$api.common.leads.visitLead(payload);
    } catch (error) {
        console.error(error);
    }
};

// Debet cards leads
const fetchDebetCardLead = (ctx, payload) => {
    if (!payload.name || !payload.phone) {
        return;
    }

    console.log('Featch debet cards lead :>>', getDebetCardsLeadModel);
};

// Calculator leads
const fetchCalcLead = (ctx, calcData) => {
    const defaultLeadData = {
        browserId: ctx.app.$cookies.get(CIB_LEAD_FINGERPRINT),
        timestamp: moment().unix(),
        url: ctx.route.path,
    };

    const {
        sum: amount,
        period,
        prepay,
        isMoscow,
        isConstruction,
        med,
        smartgrant,
        firstLoan,
        creditType,
        refinancing,
    } = calcData;

    const leadData = {
        ...defaultLeadData,
        type: LOAN_TYPES[calcData.creditType],
        program: creditType === 'mortgage' && !!calcData?.currentMortgageTypeObject?.text ? calcData?.currentMortgageTypeObject?.text : null,
        amount,
        prepay: creditType === 'credit' ? null : prepay,
        term: period * 12,
        reduceRateConditions: new URLSearchParams({
            isMed: creditType === 'mortgage' ? med : false,
            isSmartgrant: creditType === 'mortgage' ? smartgrant : false,
            isFirstLoan: creditType === 'mortgage' ? firstLoan : false,
            isMoscow: creditType === 'mortgage' ? isMoscow : false,
            isConstruction: creditType === 'mortgage' ? isConstruction : false,
            isRefinancing: creditType === 'mortgage' ? refinancing : false,
        }).toString(),
    };

    try {
        ctx.app.$api.common.leads.calcLead(leadData);
    } catch (error) {
        console.error(error);
    }
};

// FeedbackLeads
const fetchFeedbackLead = async(ctx, feedbackData) => {
    const defaultLeadData = {
        browserId: ctx.app.$cookies.get(CIB_LEAD_FINGERPRINT),
        timestamp: moment().unix(),
        formUrl: ctx.route.path,
    };

    const {
        name,
        contactPersonFullName,
        phone: contactPhone,
        inn,
        companyName,
        formType,
    } = feedbackData;

    let formTypeByUrl = null;

    if (!formType) {
        formTypeByUrl = {
            ...creditLabels,
            ...mortgageLabels,
            ...buisnessLoanLabels,
            ...commonLabels,
        }?.[defaultLeadData.formUrl] ?? null;
    }

    const unmaskedPhone = inputmask.unmask(contactPhone, {mask: '+7 (999) 999-99-99'});

    const leadData = {
        leadId: md5(unmaskedPhone),
        formType: !!formType || !!formTypeByUrl ? toCamelCase(formType || formTypeByUrl) : 'notDetermined',
        fullName: name || contactPersonFullName || 'notDetermined',
        contactPhone: unmaskedPhone,
        inn: inn || null,
        companyName: companyName || null,
        ...defaultLeadData,
    };

    const leadCookie = ctx.app.$cookies.get(CIB_LOAN_LEAD(leadData.formType)) || {};

    if (
        isEqual({...leadCookie, timestamp: null}, {...leadData, timestamp: null})
        && leadData.timestamp - leadCookie?.timestamp < 60
    ) {
        return;
    }

    ctx.app.$cookies.set(CIB_LOAN_LEAD(leadData.formType), leadData, {
        path: '/',
        maxAge: 60 * 60,
    });

    try {
        await ctx.app.$api.common.leads.formLead(leadData);
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export default (ctx, inject) => {
    // Устанавливаем browserID
    setLeadFingerprint(ctx.app);

    // Функция отправки лида о посещении сайта
    fetchVisitorLead(ctx);

    // Inject методов в контекст
    inject('fetchVisitorLead', fetchVisitorLead.bind(null, ctx));
    inject('fetchDebetCardLead', fetchDebetCardLead.bind(null, ctx));
    inject('fetchCalcLead', fetchCalcLead.bind(null, ctx));
    inject('fetchFeedbackLead', fetchFeedbackLead.bind(null, ctx));
};
